import { Label } from '@cian/ui-kit/label';
import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';
import React, { memo } from 'react';

import styles from './RepresentativeBadge.css';

const tooltipContent = (
  <div className={styles['tooltip']}>
    <ArticleHeading4>Официальный представитель</ArticleHeading4>
    <ArticleParagraph2>
      Собственник объекта, управляющая компания или агентство, которое эксклюзивно работает с этим объектом
    </ArticleParagraph2>
  </div>
);

type TRepresentativeBadgeProps = {
  onOpenTooltip?: () => void;
};

export const RepresentativeBadgeComponent: React.FC<TRepresentativeBadgeProps> = ({ onOpenTooltip }) => {
  return (
    <span className={styles['wrapper']}>
      <TooltipDesktop onOpen={onOpenTooltip} theme="white" placement="top" title={tooltipContent}>
        <Label background="accent-warning-secondary" color="accent-warning-primary" data-mark="RepresentativeBadge">
          Оф. представитель
        </Label>
      </TooltipDesktop>
    </span>
  );
};

RepresentativeBadgeComponent.displayName = 'RepresentativeBadge';

export const RepresentativeBadge = memo(RepresentativeBadgeComponent);
